// @flow
import { trackLinkWithData, trackImpression } from 'lib/analytics/fpti'

const PAGE_VARIANT_MAP = {
  SIGNUP_FOR_NETWORK_ID: 'E',
  UPGRADE_NETWORK_ID: 'A',
  PROVIDE_ADDITIONAL_NETWORK_ID_CONSENT: 'F',
}

/**
 * Track directory search impression via FPTI analytics
 * @param {Object} data - data to track with the impression
 */
export function trackSearchResultImpression(
  isRequestFlow: boolean,
  device_contacts_count: number,
  paypal_contacts_count: number
) {
  let data = { device_contacts_count, paypal_contacts_count }
  if (device_contacts_count === 0 && paypal_contacts_count === 0) {
    data = { ...data, int_err_code: '500', int_err_code_desc: 'tbd' }
  }
  trackImpression(data)
}

/**
 * Track consent page click via FPTI analytics
 * @param {Object} isRequestFlow - is in request flow
 * * @param {Object} linkName - the link name
 */
export function trackDirectorySearchClick(
  isRequestFlow: boolean,
  linkName: Object
) {
  trackLinkWithData(linkName, 'link')
}

/**
 * Track consent page click via FPTI analytics
 * @param {Object} isRequestFlow - is in request flow
 * * @param {Object} linkName - the link name
 */
export function trackContactClick(isRequestFlow: boolean, contact: Object) {
  const data = {
    recipient_ppme_member_y_n: Boolean(contact.hasNetworkId).toString(),
    account_type: contact.isUnilateral ? 'GUEST' : 'MEMBER',
  }
  trackLinkWithData('CONTACT_ID', data, 'link')
}

/**
 * Track directory search impression via FPTI analytics
 * @param {Object} data - data to track with the impression
 */
export function trackConsentImpression(actionType: string, isPreFlow: boolean) {
  const variant = PAGE_VARIANT_MAP.hasOwnProperty(actionType)
    ? PAGE_VARIANT_MAP[actionType]
    : ''
  if (variant) {
    trackImpression({
      page_variant: `Version_${variant}`,
      fltp: isPreFlow ? 'PRE' : 'IN',
    })
  }
}

/**
 * Track consent page click via FPTI analytics
 * @param {Object} actionType - data to track with the impression
 * * @param {Object} linkName - data to track with the impression
 */
export function trackConsentClick(actionType: string, linkName: string) {
  const variant = PAGE_VARIANT_MAP.hasOwnProperty(actionType)
    ? PAGE_VARIANT_MAP[actionType]
    : ''
  if (variant) {
    trackLinkWithData(linkName, { page_variant: `Version_${variant}` }, 'link')
  }
}
